/**
 * @generated SignedSource<<996fa86dc1698e1a71ea86f39e276f16>>
 * @relayHash 936286f87799e6ca0caeb3f3d609b646
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f0f7a0cd2fcd849d362525b437f482a4654f1bdbc5675ae6c88d39820ea242c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usePublishReadWatchDialogQuery$variables = {
  contentId: string;
};
export type usePublishReadWatchDialogQuery$data = {
  readonly singleContent: {
    readonly currentUserHasAncestorWatchingChildren: boolean | null | undefined;
    readonly currentUserIsWatching: boolean;
    readonly currentUserIsWatchingChildren: boolean | null | undefined;
    readonly id: string | null | undefined;
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
        readonly isWatchingBlogs: boolean;
      };
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type usePublishReadWatchDialogQuery = {
  response: usePublishReadWatchDialogQuery$data;
  variables: usePublishReadWatchDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserIsWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "currentUserHasAncestorWatchingChildren"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              },
              {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
              }
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePublishReadWatchDialogQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePublishReadWatchDialogQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "936286f87799e6ca0caeb3f3d609b646",
    "id": "3f0f7a0cd2fcd849d362525b437f482a4654f1bdbc5675ae6c88d39820ea242c",
    "metadata": {},
    "name": "usePublishReadWatchDialogQuery",
    "operationKind": "query",
    "text": "query usePublishReadWatchDialogQuery($contentId:ID!){singleContent(id:$contentId){id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "2d5cd255c069fd9713a7b4ece55fc355";

export default node;
